import type { Feature } from './types';

const title = 'Save on gas with GasHawk';

const config: Feature<{
  apiUrlTemplate: string;
}> = Object.freeze({
  title,
  isEnabled: false,
});

export default config;
